import { Container } from '@components/Container'
import { Loading } from '@components/Loading'
import { PromotionCodeForm } from '@features/promotionSetting/components/PromotionCodeForm'
import { CreatePromotionCodePageProps } from './interface'

export function CreatePromotionCodePage({
  initialValues,
  coinOptions,
  isLoading,
  createPromotionCode,
  handleLeave,
}: CreatePromotionCodePageProps) {
  return (
    <Container>
      {isLoading ? (
        <Loading className='mx-auto' />
      ) : initialValues ? (
        <PromotionCodeForm
          initialValues={initialValues}
          handleSubmit={createPromotionCode}
          goBackHandle={handleLeave}
          title='สร้างโปรโมชั่น Code'
          coinOptions={coinOptions}
        />
      ) : (
        'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง'
      )}
    </Container>
  )
}
